import type { Manifest, v4 } from '@sap/ux-specification-types';
import { descriptionSrcURL, syncRule, validity } from '../../../common/decoration/decorators';
import { addPatternForBindingChangeOfEnumOPV4 } from '../../../common/decoration/control';
import { getFooterActionsPath } from '../../application';
export class ActionAfterExecutionConfigurationFooter implements v4.ActionAfterExecutionConfiguration {
    @syncRule({
        manifest: {
            path: (pageName: string[], manifest: Manifest, sectionId: string, columnKey): string =>
                getFooterActionsPath(pageName, manifest, sectionId, columnKey) + '/afterExecution'
        }
    })
    @descriptionSrcURL('https://ui5.sap.com/#/topic/2c65f07f44094012a511d6bd83f50f2d')
    navigateToInstance?: boolean;

    @syncRule({
        manifest: {
            path: (pageName: string[], manifest: Manifest, sectionId: string, columnKey): string =>
                getFooterActionsPath(pageName, manifest, sectionId, columnKey) + '/afterExecution'
        }
    })
    enableAutoScroll?: boolean;
}

export class FooterActionV4 implements v4.FooterActionV4 {
    @syncRule({
        manifest: {
            path: getFooterActionsPath
        }
    })
    @validity({
        since: '1.84.0'
    })
    afterExecution?: ActionAfterExecutionConfigurationFooter;

    @syncRule({
        manifest: {
            path: getFooterActionsPath
        }
    })
    @validity({
        since: '1.142.0'
    })
    overflowGroup?: number;

    @syncRule({
        manifest: {
            path: getFooterActionsPath
        }
    })
    @validity({
        since: '1.139.0'
    })
    priority?: v4.ActionPriority;
}

/**
 * Sync class for Position
 */
export class CustomFooterActionPositionOP implements v4.CustomFooterActionPositionOP {
    @syncRule({
        manifest: {
            path: (pageName: string[], manifest: Manifest, sectionId: string, columnKey: string): string =>
                getFooterActionsPath(pageName, manifest, sectionId, columnKey) + '/position'
        }
    })
    @validity({
        since: '1.84.0'
    })
    anchor?: string;
    @syncRule({
        manifest: {
            path: (pageName: string[], manifest: Manifest, sectionId: string, columnKey: string): string =>
                getFooterActionsPath(pageName, manifest, sectionId, columnKey) + '/position'
        }
    })
    @validity({
        since: '1.84.0'
    })
    placement: v4.ActionPlacement;
}

export class CustomFooterActionOP implements v4.CustomFooterActionOP {
    @syncRule({
        manifest: {
            path: getFooterActionsPath
        }
    })
    @validity({
        since: '1.84.0'
    })
    text: string;

    @syncRule({
        manifest: {
            path: getFooterActionsPath
        }
    })
    @validity({
        since: '1.84.0'
    })
    position: CustomFooterActionPositionOP;

    @syncRule({
        manifest: {
            path: getFooterActionsPath
        }
    })
    @validity({
        since: '1.84.0'
    })
    press: string;

    @syncRule({
        manifest: {
            path: getFooterActionsPath
        },
        generate: addPatternForBindingChangeOfEnumOPV4
    })
    @validity({
        since: '1.84.0'
    })
    visible?: boolean;

    @syncRule({
        manifest: {
            path: getFooterActionsPath
        },
        generate: addPatternForBindingChangeOfEnumOPV4
    })
    @validity({
        since: '1.84.0'
    })
    enabled?: boolean;

    @syncRule({
        manifest: {
            path: getFooterActionsPath
        }
    })
    @validity({
        since: '1.142.0'
    })
    overflowGroup?: number;

    @syncRule({
        manifest: {
            path: getFooterActionsPath
        }
    })
    @validity({
        since: '1.139.0'
    })
    priority?: v4.ActionPriority;
}
